import { render, staticRenderFns } from "./PowerMeter.vue?vue&type=template&id=3a48fa2c&"
import script from "./PowerMeter.vue?vue&type=script&lang=js&"
export * from "./PowerMeter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports